import { put, takeLatest } from 'redux-saga/effects';
import { initSocket } from './index';
import { FETCH_USER_SUCCESS } from '../auth';

export default function* loadSocket() {
  yield takeLatest([FETCH_USER_SUCCESS], function* () {
    yield put(initSocket());
  });
}
